import { ContentNodeText } from '../../ContentNode/ContentNodeText';
import { createRuntimeOperationType, isRuntimeOperationConfig } from './common';
const isRecord = (value) => typeof value === 'object' && value !== null;
const isContentNode = (value) => isRecord(value) &&
    typeof value.kind === 'string' &&
    typeof value.typeName === 'string' &&
    'state' in value &&
    'data' in value;
const activeBuilders = new WeakSet();
const operandAsText = (currentNode, part) => {
    if (isContentNode(part)) {
        if (part === currentNode || activeBuilders.has(part)) {
            return ContentNodeText.asIntrinsicText(part);
        }
        return ContentNodeText.asText()(part);
    }
    if (part === null || part === undefined) {
        return '';
    }
    return String(part);
};
export const stringBuilderOperationType = createRuntimeOperationType({
    kind: 'STRING_BUILDER',
    dependencies: () => [],
    run: (value, context, operations) => {
        if (!Array.isArray(value)) {
            throw new Error(`STRING_BUILDER must be an array. Got ${JSON.stringify(value)}`);
        }
        if (value.some(isRuntimeOperationConfig)) {
            return value;
        }
        const currentNode = isContentNode(context.THIS) ? context.THIS : null;
        if (currentNode) {
            activeBuilders.add(currentNode);
        }
        try {
            return value.map(part => operandAsText(currentNode, part)).join('');
        }
        finally {
            if (currentNode) {
                activeBuilders.delete(currentNode);
            }
        }
    },
});
//# sourceMappingURL=string-builder.js.map